import { HttpStatusCode } from '@angular/common/http';
import { Component } from '@angular/core';
import { ThemePalette } from '@angular/material/core';
import { ProgressSpinnerMode } from '@angular/material/progress-spinner';
import { interval } from 'rxjs/internal/observable/interval';
import { Subscription } from 'rxjs/internal/Subscription';
import { Global } from 'src/app/global/globalApi';
import * as Constants from 'src/app/models/Constants';
import { CallCustomerAttributes } from 'src/app/models/customer.model';
import { Tab } from 'src/app/models/tab.model';
import { ApiService } from 'src/app/services/api.service';
import { BiometricService } from 'src/app/services/biometric.service';
import { RootScopeService } from 'src/app/services/root-scope.service';

@Component({
  selector: 'app-biometrics',
  templateUrl: './biometrics.component.html',
  styleUrls: ['./biometrics.component.scss']
})
export class BiometricsComponent {
 
 color: ThemePalette = 'primary';
  mode: ProgressSpinnerMode = 'indeterminate';
  value = 0;
  activeTab: Tab = new Tab();
  fileName : string = 'biometrics.component.ts';
  sauthMsg = Constants.SAuthStatus;
  bioConfigData = Constants.biometricConfig;
  constructor(public rootScope: RootScopeService, public biometricService: BiometricService) {
    this.activeTab = this.rootScope.activeCustTab;

  }

  

  onCancel() {
    const bd = this.activeTab.biometricData;
    this.activeTab.authenticationEgainContent.authenticationType = "";
    bd.step1Active = true; bd.step2Active = false; bd.step1Complete = false;
    bd.step1Failed = false; bd.step2Failed = false; bd.step2Complete = false;
    this.biometricService.stopTimer();
  }

  onRetry() {
    this.biometricService.stopTimer();
    if (this.activeTab.biometricData.step1Failed) {
      this.activeTab.biometricData.step1Failed = false;
      this.biometricService.sendBiometric();
    } else if (this.activeTab.biometricData.step2Failed) {
      this.activeTab.biometricData.step2Failed = false;
      this.biometricService.sendBiometric();
    }
  }

 
}